export default "__VITE_ASSET__B33cBqds__"